import React from 'react';

import { Typography } from '@sravni/react-design-system';

import img from '../imgs/Refenansirovanie.png';

import styles from './styles.module.scss';

export const SubmitSuccess: React.FC = () => {
  return (
    <div className={styles.container}>
      <img alt="Refenansirovanie" className={styles.img} src={img} />
      <Typography.Heading level={2} className={styles.title}>
        Спасибо! Ваша заявка принята
      </Typography.Heading>
      <Typography.Text className={styles.text}>
        Приём заявки означает, что редакция Сравни рассмотрит ваше предложение в течение одной недели. Мы не гарантируем
        публикацию статьи. Если ваше предложение не подошло, коротко объясним причину. Присланные статьи не
        оплачиваются. 
      </Typography.Text>
    </div>
  );
};
